import React, { useEffect, useState } from 'react';
import { MdAdd, MdClose, MdDelete, MdEdit, MdMail, MdPhone, MdSend, MdTimer, MdVisibility, MdWarning } from 'react-icons/md';
import { useNavigate, useParams } from 'react-router-dom';
import CountUp from 'react-countup';
import { ExclamationCircleFilled } from '@ant-design/icons';
import api from '../../../services/api';
import { Container, Cards, Card, Title, ViewInput, Table, Scroll } from '../../../GlobalStyles';
import loadingPhoto from "./../../../images/loading.gif"
import { toast } from 'react-toastify';
import { Button, Modal, Input, Pagination, Select } from 'antd';
import { ModalConfirm, InputTel } from './styles';
import { format } from 'date-fns';
import dayjs from 'dayjs';
import weekday from "dayjs/plugin/weekday"
import localeData from "dayjs/plugin/localeData"

const { TextArea } = Input;
const { confirm } = Modal;

dayjs.extend(weekday)
dayjs.extend(localeData)

const Comunicado = () => {

  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams()
  const [statement, setStatement] = useState({})
  const [users, setUsers] = useState([])

  useEffect(() => {
    loadStatement()
  }, []);

  useEffect(() => {
    loadUsers()
  }, []);

  async function loadUsers() {
    await api.get(`/users`).then((response) => {
      setUsers(response.data.filter((item)=>{return item.category === "franqueado"}))
    }).catch(({ response }) => {
        if (response) {
            if (response.data) {
                if (response.data.message) {
                    toast.warn(response.data.message)
                } else {
                    toast.error("Erro Interno. verifique sua conexão e tente novamente")
                }
            } else {
                toast.error("Erro Interno. verifique sua conexão e tente novamente")
            }
        } else {
            toast.error("Erro Interno. verifique sua conexão e tente novamente")
        }
    })
  }

  async function loadStatement() {
    await api.get(`/statement/${id}`).then((response) => {
      setStatement(response.data)
     }).catch(({ response }) => {
       if (response) {
         if (response.data) {
           if (response.data.message) {
             toast.warn(response.data.message)
           } else {
             toast.error("Erro Interno. verifique sua conexão e tente novamente")
           }
         } else {
           toast.error("Erro Interno. verifique sua conexão e tente novamente")
         }
       } else {
         toast.error("Erro Interno. verifique sua conexão e tente novamente")
       }
     })
    setIsLoading(false);
  }

  return (
    <Container>
      <Title>
        <h2>Comunicado</h2>
      </Title>
      {!isLoading && (
        <>
          {users?.length ? (
            <>
              <h4>{statement.title}</h4>
              <p>{statement.description}</p>
              <Scroll>
                <Table>
                  <thead>
                    <tr>
                      <td>Franqueado</td>
                      <td>Presença</td>
                      <td>Data de Confirmação</td>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      users.map(user => (
                        <tr key={user.id}>
                          <td>{user.name}</td>
                          <td>{statement.statement_confirms.some((item)=> user.id == item.user_id) ? "Confirmado" : "Pendente"}</td>
                          <td>{statement.statement_confirms.find((item)=> user.id == item.user_id) ? format(new Date(statement.statement_confirms.find((item)=> user.id == item.user_id).date), "dd/MM/yyyy HH:mm") : "Sem data"}</td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </Scroll>
            </>
          ) : (
            <div className="error">
              <p>Ocorreu um erro ao carregar franqueados</p>
            </div>
          )}
        </>
      )}
      {isLoading && <img src={loadingPhoto} style={{ background: "transparent", height: 50, width: 50 }} />}
    </Container>
  );
};

export default Comunicado;
